import React, { FC } from 'react';
import { BaseLevels, BaseSizes, ExtraLevels, Heading, Modal, Text, TextVariant } from '@kb-front/ui-kit';

import Info from 'shared/assets/images/circle-info.svg';
import { ICashBackCardDetails } from 'shared/model';
import { translate } from 'shared/utils/translation';

import './index.scss';

interface IProps {
  getInfoModalData: ICashBackCardDetails[];
  isVisibleGiftCardModal: boolean;
  setIsVisibleGiftCardModal: (value: boolean) => void;
}

const GiftCardModal: FC<IProps> = ({ getInfoModalData, isVisibleGiftCardModal, setIsVisibleGiftCardModal }) => {
  return (
    <Modal
      onClose={() => setIsVisibleGiftCardModal(false)}
      visible={isVisibleGiftCardModal}
      size={BaseSizes.S}
      header={
        <Heading level={ExtraLevels.L5}>
          <div>{translate('scoring.giftCard.title')}</div>
        </Heading>
      }
    >
      <div className="gift__card__modal">
        {getInfoModalData?.map((item: ICashBackCardDetails) => (
          <div className="gift__card__modal-element" key={item?.value}>
            <Text variant={TextVariant.SECONDARY} level={BaseLevels.L2}>
              {item?.name}
            </Text>
            <Text variant={item.isFree ? TextVariant.SUCCESS : TextVariant.DEFAULT}>{item?.value}</Text>
          </div>
        ))}

        <div className="gift__card__modal-info">
          <div className="gift__card__modal-info-img">
            <img src={Info} alt="info" />
          </div>
          <Text variant={TextVariant.DEFAULT} level={BaseLevels.L3}>
            {translate('scoring.giftMoreInfoModal.note')}
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default GiftCardModal;
